/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OperatingRulesRouteImport } from './routes/operating-rules'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EatsIndexRouteImport } from './routes/eats.index'
import { Route as DeliveryIndexRouteImport } from './routes/delivery.index'
import { Route as ProfileUsersRouteImport } from './routes/profile_.users'
import { Route as ProfileInvoicesRouteImport } from './routes/profile_.invoices'
import { Route as ProfileChangePasswordRouteImport } from './routes/profile_.change-password'
import { Route as EatsUsersRouteImport } from './routes/eats.users'
import { Route as EatsReviewsRouteImport } from './routes/eats.reviews'
import { Route as EatsOrdersRouteImport } from './routes/eats.orders'
import { Route as EatsMenuRouteImport } from './routes/eats.menu'
import { Route as EatsBranchesRouteImport } from './routes/eats.branches'
import { Route as DeliveryTariffsRouteImport } from './routes/delivery.tariffs'
import { Route as DeliveryStaffRouteImport } from './routes/delivery.staff'
import { Route as DeliveryReviewsRouteImport } from './routes/delivery.reviews'
import { Route as DeliveryReportsRouteImport } from './routes/delivery.reports'
import { Route as DeliveryOrdersRouteImport } from './routes/delivery.orders'
import { Route as DeliveryOperatingRouteImport } from './routes/delivery.operating'
import { Route as DeliveryClientsRouteImport } from './routes/delivery.clients'
import { Route as DeliveryBranchesRouteImport } from './routes/delivery.branches'
import { Route as LangOperatingRulesRouteImport } from './routes/$lang.operating-rules'
import { Route as EatsMenuRequestsRouteImport } from './routes/eats.menu_.requests'
import { Route as EatsMenuPromotionsRouteImport } from './routes/eats.menu_.promotions'
import { Route as EatsMenuProductsRouteImport } from './routes/eats.menu_.products'
import { Route as EatsMenuCategoriesRouteImport } from './routes/eats.menu_.categories'
import { Route as EatsMenuBranchesRouteImport } from './routes/eats.menu_.branches'
import { Route as EatsMenuCategoryIdRouteImport } from './routes/eats.menu_.$categoryId'
import { Route as DeliveryOrdersCreateRouteImport } from './routes/delivery.orders_.create'
import { Route as EatsMenuPromotionsPromotionIdRouteImport } from './routes/eats.menu_.promotions_.$promotionId'
import { Route as DeliveryOrdersOrderIdEditRouteImport } from './routes/delivery.orders_.$orderId.edit'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatingRulesRoute = OperatingRulesRouteImport.update({
  id: '/operating-rules',
  path: '/operating-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsIndexRoute = EatsIndexRouteImport.update({
  id: '/eats/',
  path: '/eats/',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryIndexRoute = DeliveryIndexRouteImport.update({
  id: '/delivery/',
  path: '/delivery/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileUsersRoute = ProfileUsersRouteImport.update({
  id: '/profile_/users',
  path: '/profile/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileInvoicesRoute = ProfileInvoicesRouteImport.update({
  id: '/profile_/invoices',
  path: '/profile/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileChangePasswordRoute = ProfileChangePasswordRouteImport.update({
  id: '/profile_/change-password',
  path: '/profile/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsUsersRoute = EatsUsersRouteImport.update({
  id: '/eats/users',
  path: '/eats/users',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsReviewsRoute = EatsReviewsRouteImport.update({
  id: '/eats/reviews',
  path: '/eats/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsOrdersRoute = EatsOrdersRouteImport.update({
  id: '/eats/orders',
  path: '/eats/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuRoute = EatsMenuRouteImport.update({
  id: '/eats/menu',
  path: '/eats/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsBranchesRoute = EatsBranchesRouteImport.update({
  id: '/eats/branches',
  path: '/eats/branches',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryTariffsRoute = DeliveryTariffsRouteImport.update({
  id: '/delivery/tariffs',
  path: '/delivery/tariffs',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryStaffRoute = DeliveryStaffRouteImport.update({
  id: '/delivery/staff',
  path: '/delivery/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryReviewsRoute = DeliveryReviewsRouteImport.update({
  id: '/delivery/reviews',
  path: '/delivery/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryReportsRoute = DeliveryReportsRouteImport.update({
  id: '/delivery/reports',
  path: '/delivery/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryOrdersRoute = DeliveryOrdersRouteImport.update({
  id: '/delivery/orders',
  path: '/delivery/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryOperatingRoute = DeliveryOperatingRouteImport.update({
  id: '/delivery/operating',
  path: '/delivery/operating',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryClientsRoute = DeliveryClientsRouteImport.update({
  id: '/delivery/clients',
  path: '/delivery/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryBranchesRoute = DeliveryBranchesRouteImport.update({
  id: '/delivery/branches',
  path: '/delivery/branches',
  getParentRoute: () => rootRouteImport,
} as any)
const LangOperatingRulesRoute = LangOperatingRulesRouteImport.update({
  id: '/$lang/operating-rules',
  path: '/$lang/operating-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuRequestsRoute = EatsMenuRequestsRouteImport.update({
  id: '/eats/menu_/requests',
  path: '/eats/menu/requests',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuPromotionsRoute = EatsMenuPromotionsRouteImport.update({
  id: '/eats/menu_/promotions',
  path: '/eats/menu/promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuProductsRoute = EatsMenuProductsRouteImport.update({
  id: '/eats/menu_/products',
  path: '/eats/menu/products',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuCategoriesRoute = EatsMenuCategoriesRouteImport.update({
  id: '/eats/menu_/categories',
  path: '/eats/menu/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuBranchesRoute = EatsMenuBranchesRouteImport.update({
  id: '/eats/menu_/branches',
  path: '/eats/menu/branches',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuCategoryIdRoute = EatsMenuCategoryIdRouteImport.update({
  id: '/eats/menu_/$categoryId',
  path: '/eats/menu/$categoryId',
  getParentRoute: () => rootRouteImport,
} as any)
const DeliveryOrdersCreateRoute = DeliveryOrdersCreateRouteImport.update({
  id: '/delivery/orders_/create',
  path: '/delivery/orders/create',
  getParentRoute: () => rootRouteImport,
} as any)
const EatsMenuPromotionsPromotionIdRoute =
  EatsMenuPromotionsPromotionIdRouteImport.update({
    id: '/eats/menu_/promotions_/$promotionId',
    path: '/eats/menu/promotions/$promotionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DeliveryOrdersOrderIdEditRoute =
  DeliveryOrdersOrderIdEditRouteImport.update({
    id: '/delivery/orders_/$orderId/edit',
    path: '/delivery/orders/$orderId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/operating-rules': typeof OperatingRulesRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/welcome': typeof WelcomeRoute
  '/$lang/operating-rules': typeof LangOperatingRulesRoute
  '/delivery/branches': typeof DeliveryBranchesRoute
  '/delivery/clients': typeof DeliveryClientsRoute
  '/delivery/operating': typeof DeliveryOperatingRoute
  '/delivery/orders': typeof DeliveryOrdersRoute
  '/delivery/reports': typeof DeliveryReportsRoute
  '/delivery/reviews': typeof DeliveryReviewsRoute
  '/delivery/staff': typeof DeliveryStaffRoute
  '/delivery/tariffs': typeof DeliveryTariffsRoute
  '/eats/branches': typeof EatsBranchesRoute
  '/eats/menu': typeof EatsMenuRoute
  '/eats/orders': typeof EatsOrdersRoute
  '/eats/reviews': typeof EatsReviewsRoute
  '/eats/users': typeof EatsUsersRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/profile/invoices': typeof ProfileInvoicesRoute
  '/profile/users': typeof ProfileUsersRoute
  '/delivery/': typeof DeliveryIndexRoute
  '/eats/': typeof EatsIndexRoute
  '/delivery/orders/create': typeof DeliveryOrdersCreateRoute
  '/eats/menu/$categoryId': typeof EatsMenuCategoryIdRoute
  '/eats/menu/branches': typeof EatsMenuBranchesRoute
  '/eats/menu/categories': typeof EatsMenuCategoriesRoute
  '/eats/menu/products': typeof EatsMenuProductsRoute
  '/eats/menu/promotions': typeof EatsMenuPromotionsRoute
  '/eats/menu/requests': typeof EatsMenuRequestsRoute
  '/delivery/orders/$orderId/edit': typeof DeliveryOrdersOrderIdEditRoute
  '/eats/menu/promotions/$promotionId': typeof EatsMenuPromotionsPromotionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/operating-rules': typeof OperatingRulesRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/welcome': typeof WelcomeRoute
  '/$lang/operating-rules': typeof LangOperatingRulesRoute
  '/delivery/branches': typeof DeliveryBranchesRoute
  '/delivery/clients': typeof DeliveryClientsRoute
  '/delivery/operating': typeof DeliveryOperatingRoute
  '/delivery/orders': typeof DeliveryOrdersRoute
  '/delivery/reports': typeof DeliveryReportsRoute
  '/delivery/reviews': typeof DeliveryReviewsRoute
  '/delivery/staff': typeof DeliveryStaffRoute
  '/delivery/tariffs': typeof DeliveryTariffsRoute
  '/eats/branches': typeof EatsBranchesRoute
  '/eats/menu': typeof EatsMenuRoute
  '/eats/orders': typeof EatsOrdersRoute
  '/eats/reviews': typeof EatsReviewsRoute
  '/eats/users': typeof EatsUsersRoute
  '/profile/change-password': typeof ProfileChangePasswordRoute
  '/profile/invoices': typeof ProfileInvoicesRoute
  '/profile/users': typeof ProfileUsersRoute
  '/delivery': typeof DeliveryIndexRoute
  '/eats': typeof EatsIndexRoute
  '/delivery/orders/create': typeof DeliveryOrdersCreateRoute
  '/eats/menu/$categoryId': typeof EatsMenuCategoryIdRoute
  '/eats/menu/branches': typeof EatsMenuBranchesRoute
  '/eats/menu/categories': typeof EatsMenuCategoriesRoute
  '/eats/menu/products': typeof EatsMenuProductsRoute
  '/eats/menu/promotions': typeof EatsMenuPromotionsRoute
  '/eats/menu/requests': typeof EatsMenuRequestsRoute
  '/delivery/orders/$orderId/edit': typeof DeliveryOrdersOrderIdEditRoute
  '/eats/menu/promotions/$promotionId': typeof EatsMenuPromotionsPromotionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/operating-rules': typeof OperatingRulesRoute
  '/profile': typeof ProfileRoute
  '/reset-password': typeof ResetPasswordRoute
  '/support': typeof SupportRoute
  '/welcome': typeof WelcomeRoute
  '/$lang/operating-rules': typeof LangOperatingRulesRoute
  '/delivery/branches': typeof DeliveryBranchesRoute
  '/delivery/clients': typeof DeliveryClientsRoute
  '/delivery/operating': typeof DeliveryOperatingRoute
  '/delivery/orders': typeof DeliveryOrdersRoute
  '/delivery/reports': typeof DeliveryReportsRoute
  '/delivery/reviews': typeof DeliveryReviewsRoute
  '/delivery/staff': typeof DeliveryStaffRoute
  '/delivery/tariffs': typeof DeliveryTariffsRoute
  '/eats/branches': typeof EatsBranchesRoute
  '/eats/menu': typeof EatsMenuRoute
  '/eats/orders': typeof EatsOrdersRoute
  '/eats/reviews': typeof EatsReviewsRoute
  '/eats/users': typeof EatsUsersRoute
  '/profile_/change-password': typeof ProfileChangePasswordRoute
  '/profile_/invoices': typeof ProfileInvoicesRoute
  '/profile_/users': typeof ProfileUsersRoute
  '/delivery/': typeof DeliveryIndexRoute
  '/eats/': typeof EatsIndexRoute
  '/delivery/orders_/create': typeof DeliveryOrdersCreateRoute
  '/eats/menu_/$categoryId': typeof EatsMenuCategoryIdRoute
  '/eats/menu_/branches': typeof EatsMenuBranchesRoute
  '/eats/menu_/categories': typeof EatsMenuCategoriesRoute
  '/eats/menu_/products': typeof EatsMenuProductsRoute
  '/eats/menu_/promotions': typeof EatsMenuPromotionsRoute
  '/eats/menu_/requests': typeof EatsMenuRequestsRoute
  '/delivery/orders_/$orderId/edit': typeof DeliveryOrdersOrderIdEditRoute
  '/eats/menu_/promotions_/$promotionId': typeof EatsMenuPromotionsPromotionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/operating-rules'
    | '/profile'
    | '/reset-password'
    | '/support'
    | '/welcome'
    | '/$lang/operating-rules'
    | '/delivery/branches'
    | '/delivery/clients'
    | '/delivery/operating'
    | '/delivery/orders'
    | '/delivery/reports'
    | '/delivery/reviews'
    | '/delivery/staff'
    | '/delivery/tariffs'
    | '/eats/branches'
    | '/eats/menu'
    | '/eats/orders'
    | '/eats/reviews'
    | '/eats/users'
    | '/profile/change-password'
    | '/profile/invoices'
    | '/profile/users'
    | '/delivery/'
    | '/eats/'
    | '/delivery/orders/create'
    | '/eats/menu/$categoryId'
    | '/eats/menu/branches'
    | '/eats/menu/categories'
    | '/eats/menu/products'
    | '/eats/menu/promotions'
    | '/eats/menu/requests'
    | '/delivery/orders/$orderId/edit'
    | '/eats/menu/promotions/$promotionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/operating-rules'
    | '/profile'
    | '/reset-password'
    | '/support'
    | '/welcome'
    | '/$lang/operating-rules'
    | '/delivery/branches'
    | '/delivery/clients'
    | '/delivery/operating'
    | '/delivery/orders'
    | '/delivery/reports'
    | '/delivery/reviews'
    | '/delivery/staff'
    | '/delivery/tariffs'
    | '/eats/branches'
    | '/eats/menu'
    | '/eats/orders'
    | '/eats/reviews'
    | '/eats/users'
    | '/profile/change-password'
    | '/profile/invoices'
    | '/profile/users'
    | '/delivery'
    | '/eats'
    | '/delivery/orders/create'
    | '/eats/menu/$categoryId'
    | '/eats/menu/branches'
    | '/eats/menu/categories'
    | '/eats/menu/products'
    | '/eats/menu/promotions'
    | '/eats/menu/requests'
    | '/delivery/orders/$orderId/edit'
    | '/eats/menu/promotions/$promotionId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/operating-rules'
    | '/profile'
    | '/reset-password'
    | '/support'
    | '/welcome'
    | '/$lang/operating-rules'
    | '/delivery/branches'
    | '/delivery/clients'
    | '/delivery/operating'
    | '/delivery/orders'
    | '/delivery/reports'
    | '/delivery/reviews'
    | '/delivery/staff'
    | '/delivery/tariffs'
    | '/eats/branches'
    | '/eats/menu'
    | '/eats/orders'
    | '/eats/reviews'
    | '/eats/users'
    | '/profile_/change-password'
    | '/profile_/invoices'
    | '/profile_/users'
    | '/delivery/'
    | '/eats/'
    | '/delivery/orders_/create'
    | '/eats/menu_/$categoryId'
    | '/eats/menu_/branches'
    | '/eats/menu_/categories'
    | '/eats/menu_/products'
    | '/eats/menu_/promotions'
    | '/eats/menu_/requests'
    | '/delivery/orders_/$orderId/edit'
    | '/eats/menu_/promotions_/$promotionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  OperatingRulesRoute: typeof OperatingRulesRoute
  ProfileRoute: typeof ProfileRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SupportRoute: typeof SupportRoute
  WelcomeRoute: typeof WelcomeRoute
  LangOperatingRulesRoute: typeof LangOperatingRulesRoute
  DeliveryBranchesRoute: typeof DeliveryBranchesRoute
  DeliveryClientsRoute: typeof DeliveryClientsRoute
  DeliveryOperatingRoute: typeof DeliveryOperatingRoute
  DeliveryOrdersRoute: typeof DeliveryOrdersRoute
  DeliveryReportsRoute: typeof DeliveryReportsRoute
  DeliveryReviewsRoute: typeof DeliveryReviewsRoute
  DeliveryStaffRoute: typeof DeliveryStaffRoute
  DeliveryTariffsRoute: typeof DeliveryTariffsRoute
  EatsBranchesRoute: typeof EatsBranchesRoute
  EatsMenuRoute: typeof EatsMenuRoute
  EatsOrdersRoute: typeof EatsOrdersRoute
  EatsReviewsRoute: typeof EatsReviewsRoute
  EatsUsersRoute: typeof EatsUsersRoute
  ProfileChangePasswordRoute: typeof ProfileChangePasswordRoute
  ProfileInvoicesRoute: typeof ProfileInvoicesRoute
  ProfileUsersRoute: typeof ProfileUsersRoute
  DeliveryIndexRoute: typeof DeliveryIndexRoute
  EatsIndexRoute: typeof EatsIndexRoute
  DeliveryOrdersCreateRoute: typeof DeliveryOrdersCreateRoute
  EatsMenuCategoryIdRoute: typeof EatsMenuCategoryIdRoute
  EatsMenuBranchesRoute: typeof EatsMenuBranchesRoute
  EatsMenuCategoriesRoute: typeof EatsMenuCategoriesRoute
  EatsMenuProductsRoute: typeof EatsMenuProductsRoute
  EatsMenuPromotionsRoute: typeof EatsMenuPromotionsRoute
  EatsMenuRequestsRoute: typeof EatsMenuRequestsRoute
  DeliveryOrdersOrderIdEditRoute: typeof DeliveryOrdersOrderIdEditRoute
  EatsMenuPromotionsPromotionIdRoute: typeof EatsMenuPromotionsPromotionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operating-rules': {
      id: '/operating-rules'
      path: '/operating-rules'
      fullPath: '/operating-rules'
      preLoaderRoute: typeof OperatingRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/': {
      id: '/eats/'
      path: '/eats'
      fullPath: '/eats/'
      preLoaderRoute: typeof EatsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/': {
      id: '/delivery/'
      path: '/delivery'
      fullPath: '/delivery/'
      preLoaderRoute: typeof DeliveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/users': {
      id: '/profile_/users'
      path: '/profile/users'
      fullPath: '/profile/users'
      preLoaderRoute: typeof ProfileUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/invoices': {
      id: '/profile_/invoices'
      path: '/profile/invoices'
      fullPath: '/profile/invoices'
      preLoaderRoute: typeof ProfileInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/change-password': {
      id: '/profile_/change-password'
      path: '/profile/change-password'
      fullPath: '/profile/change-password'
      preLoaderRoute: typeof ProfileChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/users': {
      id: '/eats/users'
      path: '/eats/users'
      fullPath: '/eats/users'
      preLoaderRoute: typeof EatsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/reviews': {
      id: '/eats/reviews'
      path: '/eats/reviews'
      fullPath: '/eats/reviews'
      preLoaderRoute: typeof EatsReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/orders': {
      id: '/eats/orders'
      path: '/eats/orders'
      fullPath: '/eats/orders'
      preLoaderRoute: typeof EatsOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu': {
      id: '/eats/menu'
      path: '/eats/menu'
      fullPath: '/eats/menu'
      preLoaderRoute: typeof EatsMenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/branches': {
      id: '/eats/branches'
      path: '/eats/branches'
      fullPath: '/eats/branches'
      preLoaderRoute: typeof EatsBranchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/tariffs': {
      id: '/delivery/tariffs'
      path: '/delivery/tariffs'
      fullPath: '/delivery/tariffs'
      preLoaderRoute: typeof DeliveryTariffsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/staff': {
      id: '/delivery/staff'
      path: '/delivery/staff'
      fullPath: '/delivery/staff'
      preLoaderRoute: typeof DeliveryStaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/reviews': {
      id: '/delivery/reviews'
      path: '/delivery/reviews'
      fullPath: '/delivery/reviews'
      preLoaderRoute: typeof DeliveryReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/reports': {
      id: '/delivery/reports'
      path: '/delivery/reports'
      fullPath: '/delivery/reports'
      preLoaderRoute: typeof DeliveryReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/orders': {
      id: '/delivery/orders'
      path: '/delivery/orders'
      fullPath: '/delivery/orders'
      preLoaderRoute: typeof DeliveryOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/operating': {
      id: '/delivery/operating'
      path: '/delivery/operating'
      fullPath: '/delivery/operating'
      preLoaderRoute: typeof DeliveryOperatingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/clients': {
      id: '/delivery/clients'
      path: '/delivery/clients'
      fullPath: '/delivery/clients'
      preLoaderRoute: typeof DeliveryClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/branches': {
      id: '/delivery/branches'
      path: '/delivery/branches'
      fullPath: '/delivery/branches'
      preLoaderRoute: typeof DeliveryBranchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/operating-rules': {
      id: '/$lang/operating-rules'
      path: '/$lang/operating-rules'
      fullPath: '/$lang/operating-rules'
      preLoaderRoute: typeof LangOperatingRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/requests': {
      id: '/eats/menu_/requests'
      path: '/eats/menu/requests'
      fullPath: '/eats/menu/requests'
      preLoaderRoute: typeof EatsMenuRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/promotions': {
      id: '/eats/menu_/promotions'
      path: '/eats/menu/promotions'
      fullPath: '/eats/menu/promotions'
      preLoaderRoute: typeof EatsMenuPromotionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/products': {
      id: '/eats/menu_/products'
      path: '/eats/menu/products'
      fullPath: '/eats/menu/products'
      preLoaderRoute: typeof EatsMenuProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/categories': {
      id: '/eats/menu_/categories'
      path: '/eats/menu/categories'
      fullPath: '/eats/menu/categories'
      preLoaderRoute: typeof EatsMenuCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/branches': {
      id: '/eats/menu_/branches'
      path: '/eats/menu/branches'
      fullPath: '/eats/menu/branches'
      preLoaderRoute: typeof EatsMenuBranchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/$categoryId': {
      id: '/eats/menu_/$categoryId'
      path: '/eats/menu/$categoryId'
      fullPath: '/eats/menu/$categoryId'
      preLoaderRoute: typeof EatsMenuCategoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/orders_/create': {
      id: '/delivery/orders_/create'
      path: '/delivery/orders/create'
      fullPath: '/delivery/orders/create'
      preLoaderRoute: typeof DeliveryOrdersCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eats/menu_/promotions_/$promotionId': {
      id: '/eats/menu_/promotions_/$promotionId'
      path: '/eats/menu/promotions/$promotionId'
      fullPath: '/eats/menu/promotions/$promotionId'
      preLoaderRoute: typeof EatsMenuPromotionsPromotionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delivery/orders_/$orderId/edit': {
      id: '/delivery/orders_/$orderId/edit'
      path: '/delivery/orders/$orderId/edit'
      fullPath: '/delivery/orders/$orderId/edit'
      preLoaderRoute: typeof DeliveryOrdersOrderIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  OperatingRulesRoute: OperatingRulesRoute,
  ProfileRoute: ProfileRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SupportRoute: SupportRoute,
  WelcomeRoute: WelcomeRoute,
  LangOperatingRulesRoute: LangOperatingRulesRoute,
  DeliveryBranchesRoute: DeliveryBranchesRoute,
  DeliveryClientsRoute: DeliveryClientsRoute,
  DeliveryOperatingRoute: DeliveryOperatingRoute,
  DeliveryOrdersRoute: DeliveryOrdersRoute,
  DeliveryReportsRoute: DeliveryReportsRoute,
  DeliveryReviewsRoute: DeliveryReviewsRoute,
  DeliveryStaffRoute: DeliveryStaffRoute,
  DeliveryTariffsRoute: DeliveryTariffsRoute,
  EatsBranchesRoute: EatsBranchesRoute,
  EatsMenuRoute: EatsMenuRoute,
  EatsOrdersRoute: EatsOrdersRoute,
  EatsReviewsRoute: EatsReviewsRoute,
  EatsUsersRoute: EatsUsersRoute,
  ProfileChangePasswordRoute: ProfileChangePasswordRoute,
  ProfileInvoicesRoute: ProfileInvoicesRoute,
  ProfileUsersRoute: ProfileUsersRoute,
  DeliveryIndexRoute: DeliveryIndexRoute,
  EatsIndexRoute: EatsIndexRoute,
  DeliveryOrdersCreateRoute: DeliveryOrdersCreateRoute,
  EatsMenuCategoryIdRoute: EatsMenuCategoryIdRoute,
  EatsMenuBranchesRoute: EatsMenuBranchesRoute,
  EatsMenuCategoriesRoute: EatsMenuCategoriesRoute,
  EatsMenuProductsRoute: EatsMenuProductsRoute,
  EatsMenuPromotionsRoute: EatsMenuPromotionsRoute,
  EatsMenuRequestsRoute: EatsMenuRequestsRoute,
  DeliveryOrdersOrderIdEditRoute: DeliveryOrdersOrderIdEditRoute,
  EatsMenuPromotionsPromotionIdRoute: EatsMenuPromotionsPromotionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
